var app_ui = {
	openSearchbar: function() {
		jQuery('.s-search-bar').show();
	},
	closeSearchbar: function() {
		jQuery('.s-search-bar').hide();
	},
	toggleNewsletterPopup: function() {

		jQuery(function() { //shorthand document.ready function
			jQuery('#newsletter_subscription_form').on('submit', function(e) { //use on if jQuery 1.7+
				e.preventDefault();  //prevent form from submitting
				var formData = jQuery("#newsletter_subscription_form :input").serializeArray();

				var data = {
					'action': 'send_newsletter_request',
					'newsletter_nonce': main_ajax.newsletter_nonce,
					'email': jQuery('#newsletter_subscription_form input[name="email"]').val()
				};

				// We can also pass the url value separately from ajaxurl for front end AJAX implementations
				jQuery.post( main_ajax.ajaxurl, data, function(response) {
					if ( response.code === 'sent' ) {
						jQuery('.js-ajax-result')
							.removeClass('ajax-error')
							.addClass('ajax-success')
							.html(response.message);
					}
					if ( response.code === 'already_sent' ) {
						jQuery('.js-ajax-result')
							.removeClass('ajax-success')
							.addClass('ajax-error')
							.html(response.message);
					}
				});

			});
		});

		jQuery(window).scroll( _.debounce(function() {
			if ( jQuery(document).scrollTop() >= jQuery(document).height() / 4) {
				jQuery(".c-newsletter-popup").css('opacity', 1).show("slow");
			} else {
				jQuery(".c-newsletter-popup").hide("slow");
			}
		}, 100 ) );
	}
};

jQuery( document ).ready( function( $ ) {
	if ( typeof $.mmenu === 'function' ) {
		$( '#nav' ).mmenu( {
			offCanvas: {
				position: 'right'
			}
		}, {
			clone: true
		} );
	}
	var $main = $( '.menuBox' );
	$( 'ul li ul', $main ).parent( 'li' ).addClass( 'has-children' );


	$( '.js-footer-menu' ).click( function( e ) {
		e.preventDefault();
		$( '.footerBox' ).toggleClass( 'is-active' );
	} );
} );

// Turn gravity form select elements into simple autocomplete ( no ajax loading )
if ( jQuery( '.bjmo-select2' ).length != 0 ) {
	jQuery( '.bjmo-select2' ).find( 'select' ).select2();
}

var Autocomplete = {
	place: '',
	init: function() {
		jQuery(document).ready(function(){
			autofill = new google.maps.places.Autocomplete( document.getElementById('autocomplete_address') );

			autofill.setComponentRestrictions({'country': ['nl']});

			autofill.addListener('place_changed', this.fillInAddress);
		});
	},
	fillInAddress: function() {
		alert('FILL');
		this.place = autofill.getPlace();
		alert(this.place);
		jQuery('#billing_postcode').val('');
		jQuery('#billing_address_2').val('');
		jQuery('#billing_city').val('');

		for (var i = 0; i < place.address_components.length; i++) {
			var addressType = place.address_components[i].types[0];

			// filling country field
			if ( addressType == 'country' ) {
				jQuery('#billing_country').val(place.address_components[i].short_name);
				jQuery('#billing_country').trigger('change');
			}
			// filling street address field
			if ( addressType == 'street_number' ) {
				jQuery('#billing_address_1').val(place.address_components[i].long_name);
			}
			// adding data to street address field
			if ( addressType == 'route' ) {
				var addr = jQuery('#billing_address_1').val();
				if(addr != ''){
					addr = addr +', '+ place.address_components[i].long_name;
					jQuery('#billing_address_1').val(addr);
				}
			}
			// filling state field
			if ( addressType == 'administrative_area_level_1' ) {
				var state = place.address_components[i].short_name;
				setTimeout( function(){
						jQuery('#billing_state').val(state);
						jQuery('#billing_state').trigger('change');
				}, 1500);
			}
			// filling address second field
			if ( addressType == 'administrative_area_level_2' ) {
				jQuery('#billing_address_2').val(place.address_components[i].long_name);
			}
			// filling location
			if ( addressType == 'locality' ) {
				jQuery('#billing_city').val(place.address_components[i].long_name);
			}
			// filling postal code
			if ( addressType == 'postal_code' ) {
				jQuery('#billing_postcode').val(place.address_components[i].long_name);
			}

		}
	}
};

/* MAIN.JS */

(function($) {
	$(document).ready(function() {

		// banner datalayer
		function Utils() {

		}

		Utils.prototype = {
			constructor: Utils,
			isElementInView: function (element, fullyInView) {
				var pageTop = $(window).scrollTop();
				var pageBottom = pageTop + $(window).height();
				var elementTop = $(element).offset().top;
				var elementBottom = elementTop + $(element).height();

				if (fullyInView === true) {
					return ((pageTop < elementTop) && (pageBottom > elementBottom));
				} else {
					return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
				}
			}
		};

		var Utils = new Utils();

		var banners         = $( '.banner' );
		var sponsored_posts = $( '.bjmo-sponsored-post' );

		// on load
		is_banner_in_view( banners );
		is_post_in_view( sponsored_posts );

		function is_banner_in_view( banners ) {

			var banner_in_view = false;

			banners.each( function( index, banner ) {

				var banner_links = $( banner ).find( 'a' );

				// single banner
				if ( 1 === banner_links.length ) {

					var name = $( banner_links ).data( 'name' );
					if ( name === undefined ) {
						name = $( banner ).data( 'name' );
					}

					if ( ! $( banner ).hasClass( 'ga-banner-detected' ) && name !== undefined ) {
						banner_in_view = Utils.isElementInView( banner, false );

						if ( banner_in_view ) {
							$( banner ).addClass( 'ga-banner-detected' );
							window.dataLayer = window.dataLayer || [];
							window.dataLayer.push({
								"event": "banner_impression",
								"banner_name" : name
							});
						}
					}

				// slider banners
				} else {

					var banners_object = [];

					if ( ! $( banner ).hasClass( 'ga-banner-detected' ) ) {

						banner_in_view = Utils.isElementInView( banner, false );
						if ( banner_in_view ) {

							// loop banners in slider
							banner_links.each( function( index, link ) {

								var name = $( link ).data( 'name' );
								if ( name === undefined ) {
									name = $( banner ).data( 'name' );
								}

								// add to banners_object
								banners_object.push( {
									"banner_name": name,
									"banner_position" : index + 1
								} );

							} );

							$( banner ).addClass( 'ga-banner-detected' );
							if ( banner_links.length > 0 ) {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push( {
									"event": "banner_impression",
									"banners" : banners_object
								} );
							}

						}

					}

				}

			} );
		}

		function is_post_in_view( sponsored_posts ) {

			var post_in_view = false;
			var posts_to_send = [];

			sponsored_posts.each( function( index, post ) {

				if ( ! $( post ).hasClass( 'ga-post-detected' ) ) {

					post_in_view = Utils.isElementInView( post, false );

					if ( post_in_view ) {
						post = $( post );
						post.addClass( 'ga-post-detected' );

						posts_to_send.push( {
							"title": post.data( 'title' ),
							"advertiser": post.data( 'advertiser' ) ? post.data( 'advertiser' ) : null,
						} );

					}
				}

			} );

			// send to datalayer
			if ( posts_to_send.length > 0 ) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					"event": "article_impression",
					"articles": posts_to_send
				} );
			}

		}

		$( window ).scroll( _.debounce( function() {

			is_banner_in_view( banners );
			is_post_in_view( sponsored_posts );

		}, 100 ) );

		$( '.banner a' ).click( function() {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "banner_click",
				"banner_name" : $( this ).data( 'name' ),
				"banner_target_url" : $( this ).attr( 'href' )
			});
		} );

		$( '.bjmo-sponsored-post a' ).click( function() {
			var post = $( this ).closest( '.bjmo-sponsored-post' );
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"event": "article_click",
				"articles": [{
					"title": post.data( 'title' ),
					"advertiser": post.data( 'advertiser' ) ? post.data( 'advertiser' ) : null,
				}]
			});
		} );

		$('#js-search-reset').on('click', function(event) {
			event.preventDefault();
			window.location = site_url + '/?s=';
		});

		if ( $('#s_type').length ) {
			var posttypes = $('#s_type').data('value');
			if( posttypes !== '' ) {
				posttypes = $('#s_type').data('value').split(',');
			} else {
				posttypes = [];
			}
		}
		$('#s_type input[type="checkbox"]').change(function() {
			if( $(this).is(':checked') ) {
				if( $(this).is('#check-4') ) {
					$('#s_type input[type="checkbox"]').not(this).prop('checked', false);
					posttypes = [];
				} else {
					$('#s_type input#check-4').prop('checked', false);
					posttypes.push($(this).val());
				}
			} else {
				if( $(this).not('#check-4') ) {
					posttypes.splice($.inArray($(this).val(), posttypes),1);
				}
			}
			$('#s_type').attr('data-value', posttypes);
		});

		$('#advanced-search-form').on('submit', function(event) {
			event.preventDefault();

			var url = site_url + '/?s='
			var s_size = $('#s_size div.dropdown__toggle span').data('value')
			var s_sort = $('#s_sort div.dropdown__toggle span').data('value')
			var s_section = $('#s_section div.dropdown__toggle span').data('value')
			var s_category = $('#s_category div.dropdown__toggle span').data('value')
			var s_year = $('#s_year div.dropdown__toggle span').text()
			var s_type = posttypes

			url += $('input[name="s"]').val()

			$.each(s_type, function(i, val) {
				url += '&s_type[]=' + val
			});

			if( s_size ) {
				url += '&s_size=' + s_size
			}
			if( s_sort ) {
				url += '&s_sort=' + s_sort
			}
			if( s_section !== '' ) {
				url += '&s_section=' + s_section
			}
			if( s_category !== '' ) {
				url += '&s_category=' + s_category
			}
			if( s_year !== 'All' ) {
				url += '&s_year=' + s_year
			}

			window.location = url
		});

		$('.js-podcast-filter .dropdown li').on('click', function() {
			var cat = $('.js-dropdown-cat .dropdown__options li.selected').data('id') !== undefined ? $('.js-dropdown-cat .dropdown__options li.selected').data('id') : '';
			var ill = $('.js-dropdown-ill .dropdown__options li.selected').data('id') !== undefined ? $('.js-dropdown-ill .dropdown__options li.selected').data('id') : '';
			var year = $('.js-dropdown-year .dropdown__options li.selected').data('id') !== undefined ? $('.js-dropdown-year .dropdown__options li.selected').data('id') : '';

			if ($(this).closest('.dropdown').hasClass('js-dropdown-cat')) {
				cat = $(this).data('id');
			} else if ($(this).closest('.dropdown').hasClass('js-dropdown-ill' )) {
				ill = $(this).data('id');
			} else if ($(this).closest('.dropdown').hasClass('js-dropdown-year' )) {
				year = $(this).data('id');
			}
			var url = '?&pod_cat='+ cat +'&pod_illness='+ ill +'&pod_year='+ year;

			window.location = url
		});

		// Sticky checkout sidebar to bottom
		function stickToBottom() {
		var h = window.innerHeight;
		var window_top = $(window).scrollTop();
		var window_bottom = $(window).scrollTop();
		var top = $('#stick-here').offset().top;
		var panelh = $('.order-review__inner').height();
		var footer = $('.site-footer').offset().top;
		if (window_top + h > top + 30) {
		$('.order-review__inner').addClass('stick');
		$('#stick-here').height($('.order-review__inner').outerHeight());
		}

		if (window_top + h < panelh + (30 * 2) || window_top + h > footer) {
		$('.order-review__inner').removeClass('stick');
		$('#stick-here').height(0);
		}
		}
		$(function() {
			if ($('#stick-here').length) {
				$(window).scroll(stickToBottom);
			stickToBottom();
			}
		});

		$('.js-slider').slick({
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>'
		}).show();

		var contentSlider = $('.content-slider__slider');
		var contentSliderList = $('.content-slider__list');
		var contentSliderListItem = $('.content-slider__list li');

		contentSlider.slick({
			infinite: true,
			dots: false,
			fade: true,
			arrows: false,
			autoplay: true
		}).show();

		contentSlider.on('afterChange', function() {
		  var current = $('.slick-current').attr("data-slick-index");
		  var li = parseInt(current) + 1;
			contentSliderListItem.removeClass('active');
			contentSliderList.find('li:nth-child(' + li + ')').addClass('active');
		});

		$('.js-toggle-menu').click(function() {
			$('.site-header__nav').addClass('site-header__nav--shown');
			$('.site-header__navigation-overlay').addClass('site-header__navigation-overlay--shown');
		});

		$('.js-close-menu').click(function() {
			$('.site-header__nav').removeClass('site-header__nav--shown');
			$('.site-header__navigation-overlay').removeClass('site-header__navigation-overlay--shown');
		});

		$('.js-toggle-search').click(function() {
			$('.site-header__search-wrapper').toggleClass('site-header__search-wrapper--shown');
		});

		$('.js-toggle-login').click(function() {
			$('.site-header__login-wrapper').toggleClass('site-header__login-wrapper--shown');
		});

		$('.js-toggle-submenu a').hover(function() {
			$('.site-header__submenu').addClass('site-header__submenu--shown');
		}, function() {
			$('.site-header__submenu').removeClass('site-header__submenu--shown');
		});

		$('.site-header__submenu').hover(function() {
			$('.site-header__submenu').addClass('site-header__submenu--shown');
		}, function() {
			$('.site-header__submenu').removeClass('site-header__submenu--shown');
		});

		$('.site-header__nav li:not(.js-toggle-submenu)').hover(function() {
			$('.site-header__submenu').removeClass('site-header__submenu--shown');
		});

		$('.block-categories-all-categories-wrapper button').click(function () {
			$('.block-categories-all-categories').toggleClass('block-categories-all-categories--shown');
		});


		$('.site-footer__back-to-top').click(function () {
			$('html, body').animate({scrollTop: 0}, 1000);
		});

		var toc = $('.toc ul li');
		if (toc.length > 5) {
			toc.slice(4, toc.length).wrapAll('<div class="read-more-list"></div>');
			$('.toc ul').append('<a class="toggle-read-more-list">Show more</a>');
		}

		$('.toggle-read-more-list').click(function() {
			$(this).html() == "Show lesss" ? $(this).html('Show more') : $(this).html('Show lesss');
			$('.read-more-list').slideToggle(200);
		});

		$(document).mouseup(function (e) {
			var menu = $('.site-header__nav');
			if (!menu.is(e.target) && menu.has(e.target).length === 0) {
				$('.site-header__nav').removeClass('site-header__nav--shown');
				$('.site-header__navigation-overlay').removeClass('site-header__navigation-overlay--shown');
			}
			var dropdown = $('.dropdown');

			if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
				dropdown.find('.dropdown__list').slideUp(200);
				$('.dropdown__toggle').removeClass('dropdown__toggle--active');
			}
			var header = $('.site-header');
			var search = $('.site-header__search-wrapper');
			var login = $('.site-header__login-wrapper');
			if (!header.is(e.target) && header.has(e.target).length === 0) {
				login.removeClass('site-header__login-wrapper--shown');
				search.removeClass('site-header__search-wrapper--shown');
			}

			var submenu = $('.site-header__submenu .submenu-inner');
			if (!submenu.is(e.target) && submenu.has(e.target).length === 0) {
				$('.site-header__submenu').removeClass('site-header__submenu--shown');
			}
		});

		$( 'body' ).on( 'click', '.dropdown__toggle', function() {
			$(this).toggleClass('dropdown__toggle--active');
			$(this).next('.dropdown__list').slideToggle(200);
		});

		$( 'body' ).on( 'click', '.dropdown__options li', function() {
			var option = $(this).html();
			var optionValue = $(this).data('value');

			var dropdown = $(this).parents('.dropdown');
			$('.dropdown__options li').removeClass('selected');
			$(this).addClass('selected');
			dropdown.addClass('dropdown--selected');
			dropdown.find('.dropdown__toggle span').attr('data-value', optionValue).html(option);
			dropdown.find('.dropdown__toggle').removeClass('dropdown__toggle--active');
			dropdown.find('.dropdown__list').fadeOut(200);
			if( typeof $(this).attr('data-link') !== 'undefined' ) {
				window.location = $(this).attr('data-link');
			}
		});

		if ($(window).width() > 1024) {
			var moveDiv = $('.js-move-next-desktop');
			var nextDiv = moveDiv.next();
			moveDiv.insertAfter(nextDiv);
		}

		if ($(window).width() > 768 && $(window).width() <= 1024) {
			var moveDiv = $('.js-move-next-tablet');
			var nextDiv = moveDiv.next();
			moveDiv.insertAfter(nextDiv);

			var sidebar = $('.sidebar');
			sidebar.each(function (){
				height = $(this).height();
				if (height > 800) {
					thisSB = $(this);
					newHeight = height / 1.2;
					thisSB.css('max-height', newHeight);
				}
			});
		}

		$('.tabs__next').click(function() {
			var scroller = $(this).siblings('.tabs-scroller');
			var scrollPos = scroller.scrollLeft();
			var width = scroller.find('.tabs').width() - 400;
			if (scrollPos > 0) {
				$('.tabs__prev').addClass('tabs__prev--shown');
			}
			if (scrollPos > width) {
				$(this).removeClass('tabs__next--shown');
			}
			scroller.animate({
				scrollLeft: "+=150px"
			}, 200);
		});

		$('.tabs__prev').click(function() {
			var scroller = $(this).siblings('.tabs-scroller');
			var scrollPos = scroller.scrollLeft();
			var width = scroller.find('.tabs').width() - 400;
			if (scrollPos < 300) {
				$(this).removeClass('tabs__prev--shown');
			}
			scroller.animate({
				scrollLeft: "-=150px"
			}, 200);
		});

		$('.tabs li a').click(function() {
			var tab = $(this).data('tab');
			$('.tab').removeClass('tab--active');
			$('.tab-content').removeClass('tab-content--active');
			$(this).addClass('tab--active');
			$('.tab-content[data-tab="' + tab + '"]').addClass('tab-content--active');
		});

		$('a[href*="#"]')
			.not('[href="#"]')
			.not('[href="#0"]')
			.click(function(event) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top - 30
					}, 500);
				}
			});

		$('.js-filter-year li').on( 'click', function(){

			var value = typeof $(this).attr('data-value') !== 'undefined' ? $(this).attr('data-value') : $(this).html();
			if ( 'all' === value) {
				$('.magazine-overview__row').show();
			} else {
				$('.magazine-overview__row').hide();
				$("div[data-year='" + value + "']").show();
			}
		})

		$('.js-filter-specials').on( 'click', function(){
			if ( this.checked ) {
				$("div[data-type='magazine']").hide();
			} else {
				$("div[data-type='magazine']").show();
			}

			$('.magazine-overview__row').each(function() {
				var visible = $(this).find('.row > div:visible').length;
				if ( visible == 0 ) {
					$(this).closest('.magazine-overview__row').toggleClass('hidden');
				}
			});
		})

		$('.menu-link-patients > a').addClass('btn');

		// Update hidden search type field to post the value to search page
		$('.js-search-type li').on( 'click', function() {
			$(this).closest('form').find('.js-search-type').val($(this).attr('data-value'));
		});

		$('.search-form:not(.pedia.search-form)').on('submit', function(event) {
			event.preventDefault();

			var url = site_url + '/?s=';
			var type = $(this).find('.js-search-type').val();
			url += $(this).find('input[name="s"]').val();
			if ( type !== '' ) {
				url += '&s_type[]=' + type;
			}

			window.location = url
		});

		$('.content-section').each(function() {
			if( $('.journal-widget').length > 0 && ( $(this).find('.column-4').length > 0 ) ) {
				var widget = $(this).find('.journal-widget').parent().clone();
				$(this).find('.journal-widget').parent().remove();
				if ( $(this).find('.column-4').length > 3 ) {
					widget.insertAfter($(this).find('.column-4:eq(2)'));
				} else {
					widget.insertAfter($(this).find('.column-4:last-of-type'));
				}
			}
		});

		$('.wp-caption').each(function() {
			$width = $(this).width();
			$(this).find('.img-lightbox').width($width);
			$(this).width('');
		});

		$('.js-input-eye-toggle').on('click', function(e) {
			e.preventDefault();
			if($(this).hasClass('dashicons-hidden')) {
				$(this).addClass('dashicons-visibility').removeClass('dashicons-hidden');
				$(this).siblings('input').attr('type', 'text');
			} else {
				$(this).addClass('dashicons-hidden').removeClass('dashicons-visibility');
				$(this).siblings('input').attr('type', 'password');
			}
		});

		$(document).on('click', '.site-header__nav .menu-item-has-children > a', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$('.sub-menu').not($(this).siblings('.sub-menu')).removeClass('show');
			$(this).siblings('.sub-menu').toggleClass('show');

			$(document).on('click', function(e) {
				if (!$(e.target).is('.sub-menu, .sub-menu *')) {
					$('.sub-menu').removeClass('show');
				}
			});
		});

		$('.entry-content .btn[data-toggle="collapse"]').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			$('html, body').stop();
			$(this).parent('p').next('#hiddenanswer').toggle();
		});

		// extra: put billing in shipping info, just to make sure the data is in shipping
		if($('.woocommerce-checkout').length > 0) {
			$('#shipping_hnr, #shipping_street, #shipping_prefix').on('keyup', function() {
				$('#billing_hnr').val($('#shipping_hnr').val());
				$('#billing_street').val($('#shipping_street').val());
				$('#billing_prefix').val($('#shipping_prefix').val());
			});

			$('#bill-to-different-address-checkbox').on('change', function() {
				if ($(this).prop('checked')===false){
					$('#billing_hnr').val($('#shipping_hnr').val());
					$('#billing_street').val($('#shipping_street').val());
					$('#billing_prefix').val($('#shipping_prefix').val());
				}
			});
		}

		if($('.js-extrahome-latest-mag').length > 0) {
			var getCoverHeight = $('.js-extrahome-latest-mag').height(),
				getInfoHeight = $('.extrahome__headline').height();
			if(getInfoHeight > getCoverHeight) {
				$('.extrahome__revealmore').show();
				$('.extrahome__headline').css('height', getCoverHeight);
			}

			$('.extrahome__revealmore').on('click', function() {
				$(this).hide();
				$('.extrahome__headline').css('height', 'auto');
				$('.extrahome__revealless').show();
			});

			$('.extrahome__revealless').on('click', function() {
				$(this).hide();
				$('.extrahome__headline').css('height', getCoverHeight);
				$('.extrahome__revealmore').show();
			});
		}
		// Equal height function for splide
		function setHeight(el, val) {
			if (typeof val === "function") val = val();
			if (typeof val === "string") el.style.height = val;
			else el.style.height = val + "px";
		}

		var equalheight = function ( container ) {

			var container = document.querySelectorAll( container ),
				currentTallest = 0,
				currentRowStart = 0,
				rowDivs = new Array();

			if ( 0 === container.length ) {
				return;
			}

			Array.from( container ).forEach( function( el, i ) {
				el.style.height = "auto";
				topPostion = el.offsetTop;
				if (currentRowStart != topPostion) {
					for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
						setHeight(rowDivs[currentDiv], currentTallest)
					}
					rowDivs.length = 0;
					currentRowStart = topPostion;
					currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
					rowDivs.push(el);
				} else {
					rowDivs.push(el);
					currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
				}
				for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
					setHeight(rowDivs[currentDiv], currentTallest)
				}
			} );

		}

		var sliders = document.querySelectorAll( '.splide' );

		if ( sliders.length > 0 ) {

			sliders.forEach( function( slider ) {
				var id = slider.getAttribute( 'unique_id' );
				if ( null !== id ) {
					equalheight( '.splide[unique_id="' + id + '"] .splide__slide a' );

					window.addEventListener( 'resize', _.debounce( function () {
						equalheight( '.splide[unique_id="' + id + '"] .splide__slide a' );
					} ) );
				}
			} );

		}

	});

})(jQuery);

/* MAIN>JS */

